import SMSReader from '@apps/phone/admin/components/sms_reader'
import Panel from '@admin/components/panel'
import React from 'react'

const mapPropsToPanel = (props, context) => ({
  component: <SMSReader contact={ props.contact } />
})

export default Panel(null, mapPropsToPanel)
